var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 539,
    height: 509,
    viewBox: "0 0 539 509",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_834)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 476.616,
    cy: 476.616,
    r: 140.616,
    fill: "#DD00AC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1_834)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 588.308,
    cy: 505.54,
    r: 111.692,
    fill: "#7064E9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_834",
    x: 0,
    y: 0,
    width: 953.232,
    height: 953.232,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 168,
    result: "effect1_foregroundBlur_1_834"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1_834",
    x: 236.616,
    y: 153.848,
    width: 703.384,
    height: 703.384,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 120,
    result: "effect1_foregroundBlur_1_834"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightback);
export default __webpack_public_path__ + "static/media/rightback.b3e83d485f1fcd3c236f31efb56037c5.svg";
export { ForwardRef as ReactComponent };